import { parse } from "@blooomstech/react-avro-phonetic";

// Avro phonetic: type the way you do on a Bangla phone keyboard → Bangla script.
export const toBangla = (s: string): string => {
  try {
    return parse(s);
  } catch {
    return s;
  }
};

// Convert every whitespace-separated word, preserving the spacing.
export const convertAll = (text: string): string =>
  text.split(/(\s+)/).map((seg) => (/^\s+$/.test(seg) ? seg : toBangla(seg))).join("");

// Convert only the last (just-finished) word in a string.
export const commitLast = (text: string): string => {
  const idx = text.lastIndexOf(" ");
  return text.slice(0, idx + 1) + toBangla(text.slice(idx + 1));
};
